import { ErrorMessage } from "constants/common-messages";

export const isEmpty = (value: any) => {
  return value === null || value === undefined || value.length === 0;
};

export const arrayValidation = (array: any) => {
  return Array.isArray(array) && array.length;
};

export const getErrorApis = (resp: any): string => {
  if (!resp || !resp.error) {
    return ErrorMessage.DEFAULT_ERROR;
  }

  return resp.error.message ? resp.error.message : ErrorMessage.DEFAULT_ERROR;
};

export const getErrorExcel = (error: any): string => {
  if (!error || !error.debugInfo) {
    return ErrorMessage.DEFAULT_ERROR;
  }

  return error.debugInfo.message ? error.debugInfo.message : ErrorMessage.DEFAULT_ERROR;
};

export const sortRows = (rows: Array<any>, field: string) => {
  if (!arrayValidation(rows)) {
    return [];
  }

  return rows.sort(function (a, b) {
    if (a[field] < b[field]) {
      return -1;
    }
    if (a[field] > b[field]) {
      return 1;
    }
    return 0;
  });
};
